export enum AuthFailureReason {
    missingAuthentication = 'missing-authentication',
    legacyTokenInvalid = 'legacy-token-invalid',
    betterAuthSessionInvalid = 'better-auth-session-invalid',
    legacyTokenAndBetterAuthSessionInvalid = 'legacy-token-and-better-auth-session-invalid',
}
